import * as Types from "../Constants/AllConstants";

// ============== PAYMENTS =================

export const PaySmsPackageReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PAY_SMS_PACKAGE_REQUEST:
      return { loading: true };
    case Types.PAY_SMS_PACKAGE_SUCCESS:
      return { loading: false, success: true, transaction: action.payload };
    case Types.PAY_SMS_PACKAGE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const PayEmailPackageReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PAY_EMAIL_PACKAGE_REQUEST:
      return { loading: true };
    case Types.PAY_EMAIL_PACKAGE_SUCCESS:
      return { loading: false, success: true, transaction: action.payload };
    case Types.PAY_EMAIL_PACKAGE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// ============== TRANSACTIONS =================

export const MyTransactionsReducer = (state = { transactions: [] }, action) => {
  switch (action.type) {
    case Types.MY_TRANSACTIONS_REQUEST:
      return { loading: true };
    case Types.MY_TRANSACTIONS_SUCCESS:
      return { loading: false, transactions: action.payload.content, page: action.payload.number, pages: action.payload.totalPages };
    case Types.MY_TRANSACTIONS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const MyTransactionDetailsReducer = (state = { transaction: {} }, action) => {
  switch (action.type) {
    case Types.MY_TRANSACTION_DETAILS_REQUEST:
      return { loading: true };
    case Types.MY_TRANSACTION_DETAILS_SUCCESS:
      return { loading: false, transaction: action.payload };
    case Types.MY_TRANSACTION_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
